import { useCallback, useState } from 'react';

import { WizardStepConfig } from '@bambi/component-library/src/components/Wizard/base/types';
import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { FormErrorMessage } from 'src/common/FormErrorMessage';
import { Modal } from 'src/common/primitives/Modal';
import { tripSlice } from 'src/features/trip/trip.slice';

import { ConfirmPriceStep } from './ConfirmPriceStep/ConfirmPriceStep';
import { SelectedTripsStep } from './SelectedTripsStep/SelectedTripsStep';

export default function TripBulkPriceModal() {
  const dispatch = useAppDispatch();
  const open = useAppSelector((state) => state.trip.bulkPriceModal.isOpen);
  const [error, setError] = useState<string | null>(null);

  const steps: WizardStepConfig[] = [
    {
      title: 'Trips to Price',
      render: (stepProps) => {
        return (
          <SelectedTripsStep
            {...stepProps}
            setOpen={setOpen}
            setError={setError}
          />
        );
      },
    },
    {
      title: 'Confirm Price',
      render: (stepProps) => {
        return (
          <ConfirmPriceStep
            {...stepProps}
            setOpen={setOpen}
            setError={setError}
          />
        );
      },
    },
  ];

  const setOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        dispatch(tripSlice.actions.onBulkPriceTripsModalClose());
      }
    },
    [dispatch]
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      contentClassnames="max-w-8xl"
      title="Bulk Price Trips"
      testId="trip-bulk-price-modal"
    >
      {error && (
        <div className="mb-4">
          <FormErrorMessage>{error}</FormErrorMessage>
        </div>
      )}
      <ProgressBarWizard testId="trip-bulk-price-wizard" steps={steps} />
    </Modal>
  );
}
